import { render, staticRenderFns } from "./addSizeDialog.vue?vue&type=template&id=7c51bc0a&scoped=true"
import script from "./addSizeDialog.vue?vue&type=script&lang=js"
export * from "./addSizeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c51bc0a",
  null
  
)

export default component.exports